import type { FaireProductEntity } from "../../entity_types/product";

export const p_7fhn965sgj: FaireProductEntity = {
  token: "p_7fhn965sgj",
  type: "product",
  name: "Earth Petrichor 8 oz. Candle",
  brandToken: "b_ambzy6ccke",
  brandName: "Night Blooms Goods",
  imageUrl: "https://cdn.faire.com/fastly/a702bc726e1fd3ca6d1f50de377c2ec912ca4d499fb67b2ba8ff7dede7005fac.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c2e791dca0fdb747c733c35186465c53e6bd20bf83e3ae7d8fa8f21938d0c2cb.png",
    "https://cdn.faire.com/fastly/7daadd4d6b56bfa46f1ada4b8c0e63b05f84e71d76ba2ba9b37512f4197f44c5.png"
  ],
  priceDollars: 21,
  description: "With an atmospheric scent like that after fresh rain, Earth Petrichor can be described as a mix of freshly dug up dirt from the garden and wet asphalt. Top notes of patchouli, cypress, galbanum, and vetiver base.\n\n• 100% natural soy wax\n• Non-toxic + phthalate free\n• Braided cotton wick\n• Ceramic screen printed labels (Reuse this glass)\n• Extended burn 50+ hours\n• Hand poured in Ojai, California",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:06:56.804Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
